import { render, staticRenderFns } from "./CmgRewardsExtrasHeader.vue?vue&type=template&id=c2329c5c&scoped=true&lang=pug&"
import script from "./cmg-rewards-extras-header.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-extras-header.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsExtrasHeader.vue?vue&type=style&index=0&id=c2329c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2329c5c",
  null
  
)

export default component.exports